import { EditableSiteType, SiteType } from '@features/sites/sitesAPI';

type CommonSiteInfo = (
  | {
      siteData: SiteType | EditableSiteType;
      siteId: number;
    }
  | {
      siteData: undefined;
      siteId: undefined;
    }
) & {
  siteLocation: string;
  siteNameAndLocation: string;
  isInglesSite: boolean;
};

export function getSiteLocation(site: SiteType | EditableSiteType) {
  return `${site.store_city}, ${site.store_state}`;
}

export function getSiteNameAndLocation(site: SiteType | EditableSiteType) {
  return `${site.store_name} - ${getSiteLocation(site)}`;
}

export function checkIsIngles(site: SiteType | EditableSiteType) {
  return site.store_operator === 'INGLES';
}

export function getCommonSiteInfo(
  siteData: SiteType | EditableSiteType | undefined,
): Readonly<CommonSiteInfo> {
  if (siteData === undefined) {
    return {
      siteData: undefined,
      siteLocation: 'N/A',
      siteNameAndLocation: 'N/A',
      isInglesSite: false,
      siteId: undefined,
    };
  }

  return {
    siteData,
    siteLocation: getSiteLocation(siteData),
    siteNameAndLocation: getSiteNameAndLocation(siteData),
    isInglesSite: checkIsIngles(siteData),
    siteId: siteData.store_num,
  };
}
